import React, { useEffect, useRef, useState } from "react";
import Legend from "../charts/Legend";
import ProvinceEventsMap from "../charts/ProvinceEventsMap";
import html2canvas from "html2canvas";
import "../../styles/map.css";
import { reportTypeEnum } from "./AppEnums";
import DistrictMap from "../charts/DistrictMap";
import LocalMunicipalityMap from "../charts/LocalMunicipalityMap";


export const GenericGeoMap = ({
  data,
  desc,
  dataSource,
  rptType,
  onImageSrc,
  onLegendSrc,
}) => {
  useEffect(() => {
    // Map is problematic on the modal initialization, so
    // we are intentionally causing a map resize for a redraw of the map
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 1);
    const isMap = true;
    loadMapAsImage(isMap);
    loadMapAsImage(!isMap);
  }, [onImageSrc, onLegendSrc]);

  const loadMapAsImage = async (isMap) => {
    var selector;

    // This is meant to wait for chart to render completely before capturing image
    await new Promise((resolve) => requestAnimationFrame(resolve));
    await new Promise((resolve) => setTimeout(resolve, 500));

    if (isMap && rptType === reportTypeEnum.GEO_PROVINCES) {
      selector = ".province-container";
    } else if (isMap && rptType === reportTypeEnum.GEO_MUNICIPALS) {
      selector = ".district-container";
    } else if (isMap && rptType === reportTypeEnum.GEO_LOCAL_MUNICIPALITIES){
      selector = ".local-municipalities-container";
    } else if (!isMap) selector = ".legend__preview";

    const mapElement = document.querySelector(selector);

    if (mapElement) {
      const canvas = await html2canvas(mapElement, {
        scale: 2,
        allowTaint: true,
        useCORS: true,
      });

      if (canvas.width > 0) {
        const imageUrl = canvas?.toDataURL("image/png");

        const image = new Image();
        image.src = imageUrl;

        image.onload = () => {
          if (isMap) {
            return onImageSrc(image.src);
          }

          return onLegendSrc(image.src);

        };
      }
    }
  };
  const showMap = (type) => {
    if (type === reportTypeEnum.GEO_PROVINCES)
      return (
        <div>
          <ProvinceEventsMap
            data={data}
            hoverText={desc}
            dataSource={dataSource}
            width="85%"
            annotatedCssContainer="census-info-hover__preview"
            annotatedCssText="census-info__preview"
          />
          <Legend legendClass="legend__preview" />
        </div>
      );
    else if (type === reportTypeEnum.GEO_MUNICIPALS)
      return (
        <div>
          <DistrictMap
            data={data}
            hoverText={desc}
            dataSource={dataSource}
            width="85%"
            annotatedCssContainer="census-info-hover__preview"
            annotatedCssText="census-info__preview"
          />
          <Legend legendClass="legend__preview" />
        </div>
      );
    else if (type === reportTypeEnum.GEO_LOCAL_MUNICIPALITIES)
      return (
        <div>
          <LocalMunicipalityMap
            data={data}
            hoverText={desc}
            dataSource={dataSource}
            width="85%"
            annotatedCssContainer="census-info-hover__preview"
            annotatedCssText="census-info__preview"
          />
          <Legend legendClass="legend__preview" />
        </div>
      );
  };

  return showMap(rptType);
};
